/**
 * Created by JackCui on 2021/12/1
 */

import {schemaHandle} from '../../schema-config'

export const fieldSchemaHandle = {
  handle (node, store) {
    node.pageType = store.info.type
    if (node._type && node._type !== 'field') {
      const fieldConfig = schemaHandle[node._type + 'SchemaHandle']
      if (fieldConfig?.handle) {
        return fieldConfig.handle(node, store)
      }
    }
    return node
  }
}
